import { apiClient } from './apiClient';

class OnBoardingAPI {
  isServiceable(zip) {
    return apiClient.request(
      `/service_districts/zip_code_serviceability_statuses/${zip}`,
      'GET',
      false
    );
  }

  maybeServiceable(maybeClient) {
    return apiClient.request(`/maybe_serviceable_clients`, 'POST', false, {
      phone_number: maybeClient.phone,
      email: maybeClient.email,
      zip_code: maybeClient.zip,
      contact_preference: maybeClient.contact_preference
    });
  }

  lookupMenus() {
    return apiClient.request(`/menus/live`, 'GET', false);
  }

  createClient(client) {
    return apiClient.request(`/clients`, 'POST', false, client);
  }
}

export const onBoardingAPI = new OnBoardingAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/onboardingAPI.js